<template>
  <div style="height: 100%">
    <el-card shadow="never" class="group_content_box" :loading="pageLoading">
      <div>
        <el-button size="small" type="success" @click="handleCreate">创建分组</el-button>
        <el-button v-if="selectedID.length > 0" size="small" type="danger" @click="handleDelete(selectedID)">删除选中分组</el-button>
      </div>
      <el-table :data="tableData" @selection-change="handleSelectChange($event)" :row-key="function(row) { return row.id}">
        <el-table-column :reserve-selection="true" type="selection"></el-table-column>
        <el-table-column label="分组名" prop="name"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot="default" slot-scope="{ row }">
            <el-button size="small" type="primary" @click="handleEdit(row)">修改</el-button>
            <el-button size="small" type="danger" @click="handleDelete([row.id])">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog :visible="dialogShow" :title="dialogTitle" @close="handleClose">
      <el-form :model="dialogForm" ref="dialogFormRef">
        <el-form-item label="分组名称" prop="name" :rules="[{required:true,message:'请输入分组名称'}]">
          <el-input v-model.trim="dialogForm.name" placeholder="请输入分组名称"></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "monitorGroup",
  data(){
    return {
      tableData:[],
      dialogShow:false,
      dialogTitle:"添加分组",
      dialogForm:{
        id:'',
        name:""
      },
      pageLoading:true,
      selectedID:[],
      submitLoading:false
    }
  },
  created() {
    this.getPageData()
  },
  methods:{
    getPageData(){
      this.pageLoading=true
      this.$http.get('/task/grouping/list').then(({data})=>{
        if(data.status == 'success'){
          this.tableData = data.data
        }
        this.pageLoading=false
      })
    },
    handleSelectChange(data){
      console.log(data)
      this.selectedID = data.map(item=>item.id)
    },
    handleEdit(row){
      this.dialogForm.id = row.id
      this.dialogForm.name = row.name
      this.dialogTitle ='修改分组'
      this.dialogShow = true
    },
    handleSubmit(){
      this.$refs.dialogFormRef.validate(bool=>{
        if(bool){
          this.submitLoading = true
          let result = null
          if(this.dialogTitle == '修改分组'){
            result = this.$http.post('/task/grouping/edit',this.dialogForm)
          }else{
            result = this.$http.post('/task/grouping/add',this.dialogForm)
          }
          result.then(({data})=>{
            if(data.status == 'success'){
              this.getPageData()
              this.$message.success('操作成功')
              this.handleClose()
            }else{
              this.$message.error(data.msg)
            }
            this.submitLoading = false
          })
        }
      })
    },
    handleClose(){
      this.dialogShow = false
      this.$refs.dialogFormRef.resetFields()
      this.dialogForm.name = ''
      this.dialogForm.id = ''
      this.dialogShow = false
    },
    handleCreate(){
      this.dialogShow = true
      this.dialogTitle = '添加分组'
    },
    handleDelete(ids){
      this.$confirm("您确认要删除选中的分组吗？其分组下的任务也会一并删除！",'提示',{
        type:'error'
      }).then(()=>{
        this.$http.post('/task/grouping/del',{id:ids}).then(({data})=>{
          if(data.status == 'success'){
            this.getPageData()
            this.$message.success('删除成功')
          }else{
            this.$message.error(data.msg)
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.group_content_box{
  min-height: 500px;
  //height: 100%;
}
</style>
